<template>
  <vuex-table :fields="fields" table_store="autocaller_v2/products/table">
    <template slot="actions" slot-scope="{ item }">
      <table-dropdown>
        <span class="dropdown-item-icon dropdown-item-icon--edit" @click="edit_item(item.id, item.name)">
          {{ $t('shared.component.table.action.edit') }}
        </span>
        <span
          class="dropdown-item-icon dropdown-item-icon--trash"
          @click="remove_item(item.id, item.name)"
        >
          {{ $t('shared.component.table.action.delete') }}
        </span>
        <table-dropdown />
      </table-dropdown>
    </template>
  </vuex-table>
</template>

<script>
  import { mapActions } from 'vuex';
  import { ProductsModalService } from '@autocaller_v2/modals/ProductsModalService';

  export default {
    components: {},
    computed: {
      fields() {
        return [
          {
            key: 'id',
            label: this.$t('autocaller_v2.task.field.id'),
            sortable: false
          },
          {
            key: 'name',
            label: this.$t('autocaller_v2.products.table.name'),
            sortable: true,
          },
          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            sortable: false,
            class: 'text-center',
            thStyle: { width: '120px' }
          }
        ];
      }
    },
    methods: {
      ...mapActions('autocaller_v2/products/table', ['getAsyncData']),
      edit_item: function (id, name) {
        ProductsModalService.edit(id, name).on('success', () => this.getAsyncData());
      },
      remove_item: function (id, name) {
        ProductsModalService.remove(id, name).on('success', () => this.getAsyncData());
      }
    }
  };
</script>
